import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { Route, RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { VistaTramiteContainerComponent } from './components/vista-tramite-container/vista-tramite-container.component';
import { VistaTramiteTableComponent } from './components/vista-tramite-table/vista-tramite-table.component';
import { AcreditacionEmpresaFormContainerComponent } from '../empresas/acreditacion-empresa/features/acreditacion-empresa/components/acreditacion-empresa-form-container/acreditacion-empresa-form-container.component';
import { EmpresaGuardService } from '../guards/empresa-guard.service';

const routes: Route[] = [
  {
    path: 'vista-tramites',
    component: VistaTramiteContainerComponent,
  },
  {
    path: 'acreditacion-empresa',
    canActivate: [EmpresaGuardService],
    component: AcreditacionEmpresaFormContainerComponent,
  },
  {
    path: 'acreditacion-empresa/:id',
    canActivate: [EmpresaGuardService],
    component: AcreditacionEmpresaFormContainerComponent,
  }
];

@NgModule({
  declarations: [VistaTramiteContainerComponent, VistaTramiteTableComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatCardModule,
    MatButtonModule,
    RouterModule.forChild(routes)
  ]
})
export class VistaTramiteModule { }
